import React, { useEffect, useState } from "react";
import { useForm, useFormState } from "react-hook-form";
import {
  View,
  Text,
  StyleSheet,
  Dimensions,
  TouchableHighlight,
  TouchableOpacity,
} from "react-native";
import Width from "../../../assets/Width";
import { Button } from "../../../components/core/Button";
import { Input } from "../../../components/core/Input";
import { Icon } from "@iconify/react";
import Tooltip from "react-native-walkthrough-tooltip";
import { Color, globalFontStyle, globalStyle } from "../../../assets";
import TradingFeeDiscount from "./TradingFeeDiscount";
import Colors from "../../../assets/Color/Colors";
import { info } from "../../../utils/images";
import {globalConfigurableData, globalConst} from "../../../utils/globalConstant";
import { Network } from "../../../utils/network";
import FastImage from "../../../common/FastImage";

const TradeInfoInstant = ({
  eventDetails,
  orderStatus,
  onClick,
  orderBookSelectedData,
  onBottomSheetOpen,
  invested_amount,
  isDummy,
}) => {
  const [YesSelected, setYesSelected] = useState(
    orderBookSelectedData?.callvalue === "Y"
  );
  const yesNoSelected = (isYes) => {
    if (isYes) {
      setYesSelected(true);
      const amount = watchamount;
      setValue("currentAmount", "100");
      if (amount === 100) {
        getUpdatedPrice("Y", true);
      }
      setTradingFee((watchamount * 0.01)?.toFixed(2));
    } else {
      setYesSelected(false);
      const amount = watchamount;
      setValue("currentAmount", "100");
      if (amount === 100) {
        getUpdatedPrice("N", true);
      }
      setTradingFee((watchamount * 0.01)?.toFixed(2));
    }
  };

  const {
    control,
    formState: { errors, isValid, isSubmitting },
    handleSubmit,
    reset,
    watch,
    setValue,
  } = useForm({ mode: "onChange" });
  const [toolTipVisible, setToolTipVisible] = useState(false);

  useEffect(() => {
    reset({
      currentPrice:
        orderBookSelectedData?.callvalue === "Y"
          ? eventDetails?.newYCP?.toFixed(2)
          : eventDetails?.newNCP?.toFixed(2),
      currentAmount: "100",
    });
  }, [eventDetails?.newYCP]);

  const watchprice = watch("currentPrice");
  const watchamount = watch("currentAmount");
  const [tradingFee, setTradingFee] = useState(
    (watchamount * 0.01)?.toFixed(2)
  );

  useEffect(() => {
    getUpdatedPrice();
  }, [watchamount]);

  const getUpdatedPrice = async (
    isYesSelected = null,
    isLoaderShow = false
  ) => {
    if (watchamount > 0 && watchamount <= 1000000 && true) {
      const data = {
        eventId: eventDetails.id,
        action: "buy",
        callvalue: isYesSelected ? isYesSelected : YesSelected ? "Y" : "N",
        amount: watchamount,
        shares: 1,
        variableLiquidity: eventDetails.is_variable_liquidity_pool,
      };
      //if (isLoaderShow) setLoaderActive(true);

      try {
        let res;
        if (data.variableLiquidity) {
          res = await Network.getUpdatedPrice(data);
        } else {
          res = await Network.getTruePrice(data);
        }

        //if (isLoaderShow) setLoaderActive(false);
        if (res?.data?.success) {
          setTradingFee(res?.data?.data?.trading_fee?.toFixed(2));
          setValue("currentPrice", res?.data?.data?.ex_price?.toFixed(2));
          return res?.data;
        }
      } catch (e) {
        //if (isLoaderShow) setLoaderActive(false);
        throw e;
      }
    }
  };

  const onPlaceOrder = async (data) => {
    let inputObj = {
      appVersion: globalConst.appVersion,
      callvalue: YesSelected ? "Y" : "N",
      coins: `${data.currentAmount}`,
      noofcontracts: 1,
      probeid: eventDetails?.id,
      proptionid: YesSelected ? 9 : 10,
      ptype: "bet",
      tradeType: "Buy",
      //preventSlippage: data?.preventSlippage,
      trade_initiated_price: parseFloat(watchprice)?.toFixed(2),
    };
    inputObj = {
      ...inputObj,
      ...{
        trade_initiated_price: parseFloat(inputObj.trade_initiated_price),
      },
    };
    if (!isSubmitting) {
      const res = await Network.buyOrder(inputObj);

      if (res?.success) {
        res.data.coins = watchprice;
      } else {
        //res.success = false;
      }

      orderStatus(res);
    }
  };

  const onCounterUpdate = (field, action) => {
    const currentValue = parseFloat(watch(field)) || 0;
    const newValue = action === 'increment' ? currentValue + 1 : currentValue - 1;
    
    if (field === 'currentAmount') {
      if (newValue >= 1 && newValue <= 200000) {
        setValue(field, newValue.toString(), {
          shouldValidate: true,
          shouldDirty: true,
        });
      }
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <View
        style={{
          flexDirection: "row",
          marginBottom: 30,
          width: Width.width - 30,
          flex: 1,
        }}
      >
        <Button
          variant="trading"
          onPress={() => yesNoSelected(true)}
          style={{ 
            flex: 1,
            marginRight: 10,
          }}
          className={`trading-button ${YesSelected ? 'yes-selected' : 'yes-inactive'}`}
          textStyle={{
            ...globalFontStyle.appFontBody,
            color: YesSelected ? Colors.bgWhite : Colors.black,
          }}
        >
          Yes
        </Button>
        <Button
          variant="trading"
          onPress={() => yesNoSelected(false)}
          style={{ 
            flex: 1,
          }}
          className={`trading-button ${!YesSelected ? 'no-selected' : 'no-inactive'}`}
          textStyle={{
            ...globalFontStyle.appFontBody,
            color: !YesSelected ? Colors.bgWhite : Colors.black,
          }}
        >
          No
        </Button>
      </View>

      <View>
        <View style={styles.tableContainerRow}>
          <Text style={styles.fieldLeft}>Order Type</Text>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text style={styles.fieldRight}>Market</Text>
            <Tooltip
              isVisible={toolTipVisible}
              contentStyle={globalStyle.toolTipStyle}
              content={
                <View style={{}}>
                  <Text
                    style={{
                      ...globalFontStyle.appFontSubText,
                      color: Colors.black,
                    }}
                  >
                    Hello text gregv vre gver
                  </Text>
                </View>
              }
              placement="top"
              onClose={() => setToolTipVisible(false)}
              showChildInTooltip={false}
              disableShadow={true}
              backgroundColor={"rgba(0,0,0)"}
              allowChildInteraction={true}
            >
              <TouchableHighlight
                style={globalStyle.infoIcon}
                onPress={() => setToolTipVisible(true)}
              >
                <FastImage
                  style={styles.infoStyle}
                  source={globalConfigurableData?.info()}
                />
              </TouchableHighlight>
            </Tooltip>
          </View>
        </View>
        <View style={styles.tableContainerRow}>
          <Text style={styles.fieldLeft}>Price</Text>
          <View style={{
            flex: 1,
            backgroundColor: globalConfigurableData.cardBgColor,
            borderRadius: 8,
            borderWidth: 1,
            overflow: 'hidden',
            borderColor: errors?.currentPrice ? Colors.red : globalConfigurableData.borderColor,
          }}>
            <Input
              name="currentPrice"
              placeholder=""
              control={control}
              variant="large"
              disabled={true}
              containerStyle={{marginBottom: 0}}
              style={{borderWidth: 0}}
              inputStyle={{
                borderWidth: 0,
                backgroundColor: 'transparent',
                textAlign: 'center',
              }}
              fullWidth
              numeric={true}
              rules={{
                required: "Price should be between ₹1 and ₹99",
                min: {
                  value: 1,
                  message: "Price should be between ₹ 1 and ₹ 99",
                },
                max: {
                  value: 99,
                  message: "Price should be between ₹ 1 and ₹ 99",
                },
              }}
            />
          </View>
        </View>
        {errors?.currentPrice?.type === "required" && (
          <Text style={globalStyle.errorText}>{errors?.currentPrice.message}</Text>
        )}
        {(errors?.currentPrice?.type === "min" ||
          errors?.currentPrice?.type === "max") && (
          <Text style={globalStyle.errorText}>{errors?.currentPrice.message}</Text>
        )}
        <View style={styles.tableContainerRow}>
          <Text style={styles.fieldLeft}>Amount</Text>
          <View style={{
            flex: 1,
            flexDirection: 'row',
            alignItems: 'center',
            backgroundColor: globalConfigurableData.cardBgColor,
            borderRadius: 8,
            borderWidth: 1,
            overflow: 'hidden',
            borderColor: errors?.currentAmount ? Colors.red : globalConfigurableData.borderColor,
          }}>
            <TouchableOpacity
              onPress={() => onCounterUpdate('currentAmount', 'decrement')}
              style={{
                height: 46,
                width: 46,
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Icon
                icon="mdi:minus"
                width={20}
                height={20}
                color={globalConfigurableData.primaryTextColor1}
              />
            </TouchableOpacity>
            <View style={{
              width: 1,
              alignSelf: 'stretch',
              backgroundColor: errors?.currentAmount ? Colors.red : globalConfigurableData.borderColor,
            }} />
            <View style={{flex: 1}}>
              <Input
                name="currentAmount"
                placeholder=""
                control={control}
                variant="large"
                containerStyle={{marginBottom: 0}}
                style={{borderWidth: 0}}
                inputStyle={{
                  borderWidth: 0,
                  backgroundColor: 'transparent',
                  textAlign: 'center',
                }}
                fullWidth
                numeric={true}
                rules={{
                  required: true,
                  max: {
                    value: 200000,
                    message: "Cannot purchase shares worth more than Rs. 200000 at a time",
                  },
                }}
              />
            </View>
            <View style={{
              width: 1,
              alignSelf: 'stretch',
              backgroundColor: errors?.currentAmount ? Colors.red : globalConfigurableData.borderColor,
            }} />
            <TouchableOpacity
              onPress={() => onCounterUpdate('currentAmount', 'increment')}
              style={{
                height: 46,
                width: 46,
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Icon
                icon="mdi:plus"
                width={20}
                height={20}
                color={globalConfigurableData.primaryTextColor1}
              />
            </TouchableOpacity>
          </View>
        </View>
        {errors?.currentAmount?.type === "max" && (
          <Text style={globalStyle.errorText}>{errors?.currentAmount?.message}</Text>
        )}
        <View style={styles.tableContainerRow}>
          <Text style={styles.fieldLeft}>Total Shares</Text>
          <Text style={styles.fieldRight}>
            {(watchamount / watchprice)?.toFixed(2)} x{" "}
            {YesSelected ? " Yes" : " No"}
          </Text>
        </View>
        <View style={styles.tableContainerRow}>
          <View>
            <Text style={styles.fieldLeft}>Potential Returns</Text>
            <Text style={styles.fieldLeft1}>(Rs 100/- per share)</Text>
          </View>

          <Text style={styles.fieldRight}>
            {" "}
            {parseFloat((watchamount * 100) / watchprice)?.toFixed(2)}
          </Text>
        </View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "center",
            marginTop: 40,
            marginBottom: 5,
          }}
        >
          <Text style={styles.tradingText}>including trading fees:</Text>
          <Text style={styles.tradingFeeVal}>
            {" "}
            {watchamount ? tradingFee : 0}
          </Text>
        </View>
        <TradingFeeDiscount />
      </View>
      <View style={[globalStyle.customBtnParentModalStyle]}>
        <Button
          variant="trading"
          onPress={handleSubmit(onPlaceOrder)}
          style={{
            minHeight: 48,
            borderRadius: 8,
          }}
          className={`trading-button ${
            !isValid 
              ? 'disabled'
              : YesSelected 
                ? 'yes-selected' 
                : 'no-selected'
          }`}
          disabled={!isValid}
          textStyle={{
            ...globalFontStyle.appFontBody,
            color: !isValid ? Colors.grey1 : Colors.bgWhite,
          }}
          translate
        >
          Place Order
        </Button>
      </View>
    </View>
  );
};

export default TradeInfoInstant;

const styles = StyleSheet.create({
  fieldLeft: {
    color: Color.black,
    ...globalFontStyle.appFontBody,
  },
  fieldLeft1: {
    color: Color.black,
    ...globalFontStyle.appFontSmallText,
  },
  fieldRight: {
    color: Color.black,
    ...globalFontStyle.appFontBody,
  },
  tradingText: {
    color: Color.black2,
    ...globalFontStyle.appFontSmallText,
  },
  tradingFeeVal: {
    color: Color.black,
    ...globalFontStyle.appFontSmallText,
  },
  tableContainerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    flex: 1,
    paddingVertical: 15,
    alignItems: "center",
  },
  infoStyle: {
    width: 12.5,
    height: 12.5,
  },
  tradingButtonContainer: {
    flexDirection: "row",
    marginBottom: 30,
    width: Width.width - 30,
    flex: 1,
  },
  tradingButton: {
    flex: 1,
    minHeight: 48,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  tradingButtonText: {
    ...globalFontStyle.appFontBody,
  },
});
